"use client";

/**
 * useAuth — convenience hook. Use this in feature components.
 * Wraps useAuthContext for a cleaner import path.
 */
export { useAuthContext as useAuth } from "./AuthContext";
